import { useTranslations } from 'use-intl';

import { TheySaidLogoIcon } from '@/shared-ui';

export default function SurveyAiFormsAiSectionPoweredBy() {
  const t = useTranslations('AIForms.poweredBy');

  return (
    <div
      data-test='powered-by'
      className='flex flex-col items-start justify-start gap-1'
    >
      <div className='flex items-center gap-1 text-(--brand-secondary)'>
        <div className='text-xs/3 font-normal'>{t('label')}</div>
        <TheySaidLogoIcon color='currentColor' width={44} height={10} />
      </div>

      <div className='text-xs text-(--brand-secondary)'>
        <a
          href='https://www.theysaid.io/'
          data-test='powered-by-link'
          className='text-(--brand-secondary) underline transition-colors'
        >
          {t('tryItForFree')}
        </a>
        <span className='mx-1'>|</span>
        <a
          href='https://www.theysaid.io/terms'
          data-test='powered-by-link'
          className='text-(--brand-secondary) underline transition-colors'
        >
          {t('termsOfUse')}
        </a>
      </div>
    </div>
  );
}
